// Fix for server-side rendering of styled components until v6
import styled from 'styled-components';
export * from 'styled-components';
// @ts-ignore
const defaultStyled = typeof styled === 'function' ? styled : styled.default;
export { defaultStyled as default };
